module.exports = __webpack_public_path__ + "661b20e5885949cef456b6b85b3ed140.jpg";